import { config } from "../Environment";

// ─── Types ───────────────────────────────────────────────────────────────────

export interface ProgressReport {
  _id: string;
  fiUser: string;
  fiTakeaway: string;
  content: string;
  createdOn: number;
  createdBy: string;
}

export interface ProgressReportListResponse {
  type: "list";
  list: ProgressReport[];
}

// ─── API Functions ───────────────────────────────────────────────────────────

export const createProgressReport = async (
  retryFetch: Function,
  takeawayId: string,
  content: string
): Promise<ProgressReport> => {
  const response = await retryFetch(
    `${config.API_BASE}/api/progress-reports`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ takeawayId, content }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to create progress report");
  }

  const data = await response.json();
  return data.item || data;
};

export const listProgressReports = async (
  retryFetch: Function,
  takeawayId: string
): Promise<ProgressReport[]> => {
  const response = await retryFetch(
    `${config.API_BASE}/api/progress-reports/${takeawayId}`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch progress reports");
  }

  const data = await response.json();
  return data.list || data;
};

export const deleteProgressReport = async (
  retryFetch: Function,
  id: string
): Promise<void> => {
  const response = await retryFetch(
    `${config.API_BASE}/api/progress-reports/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Failed to delete progress report");
  }
};
